// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"c3355946","248":"6be64ada","382":"f786ec59","488":"a4e1ee6e","566":"3fb129e0","622":"b8a392a8","649":"cfa6b21e","667":"03128a55","702":"59b60dc2","866":"b96c8209","901":"a4242b74"}[chunkId] + ".chunk.js";
};